import { render, staticRenderFns } from "./RunnitNavTabs.vue?vue&type=template&id=38ece26a&scoped=true"
import script from "./RunnitNavTabs.vue?vue&type=script&lang=ts"
export * from "./RunnitNavTabs.vue?vue&type=script&lang=ts"
import style0 from "./RunnitNavTabs.vue?vue&type=style&index=0&id=38ece26a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ece26a",
  null
  
)

export default component.exports